import React from 'react'
import { Link, useLocation } from 'react-router-dom'

interface HeaderProps {
  subtitle?: string
}

export default function Header({ subtitle }: HeaderProps) {
  const location = useLocation()
  const isPairings = location.pathname.includes('/pairings')

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-8">
            <div>
              <h1 className="text-xl font-bold text-gray-900">Google Font Explorer</h1>
              {subtitle && (
                <p className="text-sm text-gray-500">{subtitle}</p>
              )}
            </div>

            <nav className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
              <Link
                to="/google-font-explorer"
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  !isPairings
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                All Fonts
              </Link>
              <Link
                to="/google-font-explorer/pairings"
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  isPairings
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Pairings
              </Link>
            </nav>
          </div>

          <a
            href="/"
            className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
          >
            Back to Nimble Labs
          </a>
        </div>
      </div>
    </header>
  )
}
